export const AvatarIcon = () => (
    
    <svg
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="34" height="34" rx="17" fill="#CEDDDD" />
      <mask
        id="mask0_6602_277"
            style={{maskType:"alpha"}}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="34"
        height="34"
      >
        <rect width="34" height="34" rx="17" fill="#D8D9DD" />
      </mask>
      <g mask="url(#mask0_6602_277)">
        <path
          d="M12.1033 26.1856L7.08013 28.5805C6.78536 28.721 6.52045 28.8937 6.27396 29.0819C-3.26278 42.2248 11.6801 47.2222 15.8107 47.2222C19.9108 47.2222 36.2089 44.4112 27.8906 29.1308C27.6212 28.932 27.329 28.7532 27.005 28.6122L21.6261 26.2617C20.9311 25.958 20.4921 25.3372 20.4921 24.6581V22.8134C20.6433 22.6629 20.8161 22.4697 21.001 22.2415C21.7341 21.3364 22.2887 20.3408 22.673 19.2963C23.363 19.1103 23.8712 18.5533 23.8712 17.8915V15.9224C23.8712 15.4893 23.6507 15.1023 23.3083 14.8313V11.985C23.3083 11.985 22.673 7.55554 17.1144 7.55554C11.5557 7.55554 10.9204 11.985 10.9204 11.985V14.8313C10.5773 15.1023 10.3575 15.4893 10.3575 15.9224V17.8915C10.3575 18.4101 10.6695 18.8665 11.1364 19.1303C11.6992 21.272 13.1731 22.8134 13.1731 22.8134V24.6125C13.1725 25.2677 12.7621 25.8713 12.1033 26.1856Z"
          fill="url(#paint0_linear_6602_277)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_6602_277"
          x1="16.6852"
          y1="7.55554"
          x2="16.6852"
          y2="47.2222"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="0.74609" stopColor="white" stopOpacity="0.22" />
        </linearGradient>
      </defs>
    </svg>

)